export class Entity {
  id: number;

  constructor(id: number) {
    this.id = id;
  }
}
